import * as API_CONSTANT from '../constants'

export const getUserInfoByAuthID = (authid, authProvider) => (
  fetch(`${API_CONSTANT.fms_sso_path}/user/authid/getInfo`, {
      method: 'POST',
      headers: API_CONSTANT.headers,
      body: JSON.stringify({
          authid, 
          authProvider,
          platform: 'web',
      })
  })
  .then(res => res.json())
)

//  { 
//     "authProvider": "firebase", 
//     "authid": "cO1MJamXaBRzCA8Kjy1j7tzJMoI2", 
//     "deviceId": "cfe5ad14cdeecc8d", 
//     "fcmToken": "ep4OQOzkRGKS9k82KJJWhL:APA91bHxRpTSo5-zjw4gpK5hI9kee87UeIJsRmx3jeHmNJS_3hzwb8Bk_Otb_2-4xctsOAY43sAZ19JPwtW6SkZPxn1mjNjgMYCDEsq5W7GwL82ulz3UCmI", 
//     "platform": "mobile"
// }